import { useFormContext, Controller } from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';

type IProps = {
  name: string;
  children: React.ReactNode;
};

type RHFSelectProps = IProps & TextFieldProps;

export const RHFSelect = ({ name, children, onChange, ...other }: RHFSelectProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          select
          fullWidth
          SelectProps={{ native: true }}
          error={!!error}
          helperText={error?.message}
          onChange={(e) => {
            field.onChange(e);
            onChange?.(e);
          }}
          {...other}
        >
          {children}
        </TextField>
      )}
    />
  );
};
